"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthenticated = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useAuthenticated = function useAuthenticated() {
  var context = _react["default"].useContext(_context.AuthContext);
  /* istanbul ignore next */


  if (!context) {
    throw new Error('useAuthenticated must be used within an AuthProvider');
  }

  var state = context.state;
  return state;
};

exports.useAuthenticated = useAuthenticated;